import { isActivationKey, markInitialised } from '../utils/dom'

export default function initVideo() {
	// Custom Vimeo/Youtube play buttons
	const componentVideos = document.querySelectorAll('.video-player')

	componentVideos.forEach((video) => {
		if (!markInitialised(video, 'jsVideo')) return

		const cover = video.querySelector('.video-player__cover')
		const option = video.getAttribute('data-option')

		if (!cover) return

		let playMedia = null

		if (option === 'youtube' || option === 'vimeo') {
			const iframe = video.querySelector('iframe')
			if (!iframe) return

			const iframeUrl = iframe.src
			playMedia = () => {
				iframe.src = iframeUrl.replace('autoplay=0', 'autoplay=1')
				cover.classList.add('hidden')
			}
		} else if (option === 'mp4') {
			const videoEl = video.querySelector('video')
			if (!videoEl) return

			playMedia = () => {
				videoEl.play()
				cover.classList.add('hidden')
			}
		}

		if (!playMedia) return

		const trigger = cover.querySelector('button') || cover

		if (trigger === cover) {
			cover.setAttribute('role', 'button')
			cover.tabIndex = 0
			trigger.addEventListener('keydown', (event) => {
				if (isActivationKey(event)) {
					event.preventDefault()
					playMedia()
				}
			})
		}

		cover.addEventListener('click', playMedia)
	})
}
